/** Start over's toast (TMMAPP-0119 §E 26c): the served counts, by tmm-api's table names. */
import type { TFunction } from 'i18next';
import { formatList } from '@/i18n/format';

/** The served counts the toast names, in its order (tmm-api's table names). */
export const START_OVER_COUNTS = [
  'accounts',
  'transactions',
  'virtual_accounts',
  'envelopes',
  'payees',
  'planned_series',
  'meetings',
  'import_batches',
] as const;

/** "Deleted 2 accounts, 140 transactions and 1 virtual account." — zeros and other keys omitted. */
export function startOverSummary(
  t: TFunction,
  counts: Readonly<Record<string, number>>,
  locale: string,
): string {
  const parts = START_OVER_COUNTS.flatMap((key) => {
    const count = counts[key] ?? 0;
    return count > 0 ? [t(`settings.startOver.count.${key}`, { count })] : [];
  });
  return parts.length === 0
    ? t('settings.startOver.doneEmpty')
    : t('settings.startOver.done', { list: formatList(parts, locale) });
}
